/* 
Site global JS, as a rule of thumb, 
this should only contain JS that is 
needed for the majority of pages on the site.
*/
import './resource_v1';

(function($){
	
	$(document).ready(function(){
        // here we go

        // vanilla JavaScript external links in new tab.
        var links = document.links;

        for (var i = 0, linksLength = links.length; i < linksLength; i++) {
            if (links[i].hostname != window.location.hostname) {
                links[i].target = '_blank';
            } else if ( links[i].href.indexOf(".pdf") != -1 ) {
                links[i].target = '_blank';
            }
        }

        $("[data-toggle=popover]").popover();

        var showScrollTop = function(){
            var offset = 500;
            var duration = 500;
            if ( $(this).scrollTop() < offset ) {
                $('.topbutton').fadeOut(duration);
            } else if ( $(this).scrollTop() >= offset ) {
                $('.topbutton').fadeIn(duration);
            }
        }
        showScrollTop();
        $(window).scroll(showScrollTop);

        $('.topbutton').on('click', function( e ){
            e.preventDefault();

            var speed = 250;
            $('html, body').animate({scrollTop:0}, speed);
            return false;
        });

        $( '#search-modal' ).on( 'shown.bs.modal', function(){
            $( '.search-form input[name="s"]' ).focus();
        } );

	});
	
})(jQuery);

import './nav';
import './cart';
import './infobug';